export const INIT_PROFILI_ORARI = 'INIT_PROFILI_ORARI';
export const INIT_PROFILI_ORARI_RESPONSE = 'INIT_PROFILI_ORARI_RESPONSE';

export const GET_PROFILO_ORARIO_SINGOLO_INDIVIDUO_SUCCESS = 'GET_PROFILO_ORARIO_SINGOLO_INDIVIDUO_SUCCESS';

export const ADD_PROFILO_ORARIO_SUCCESS = 'ADD_PROFILO_ORARIO_SUCCESS';
export const ADD_PROFILO_ORARIO_FAIL = 'ADD_PROFILO_ORARIO_FAIL';

export const GET_RECUPERO_PROFILI_ORARI_SUCCESS = 'GET_RECUPERO_PROFILI_ORARI_SUCCESS';
export const GET_RECUPERO_PROFILI_ORARI_FAIL = 'GET_RECUPERO_PROFILI_ORARI_FAIL';

